import Stack from '@mui/material/Stack';
import { JSONSchema7 } from 'json-schema';
import { useContext, useEffect, useRef, useState } from 'react';
import { getAttachmentUrl } from '../../Shared/ajax';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import {
  WorkflowEngineContext,
  WorkflowEngineMode
} from '../../WorkflowEngine/workflowEngineReducer';
import Dimensions from './utilities/dimensions';
import { useWindowSize } from 'usehooks-ts';

export default (control: ControlState) => {
  const { state } = useContext(WorkflowEngineContext);
  const { versionExternalId, mode } = state;

  const properties = control.schema?.properties as JSONSchema7Properties;
  const labelSchema = properties['label'] as JSONSchema7;
  const dataSchema = properties['data'] as JSONSchema7;
  const externalIdSchema = properties['externalId'] as JSONSchema7;
  const widthSchema = properties['width'] as JSONSchema7;
  const heightSchema = properties['height'] as JSONSchema7;

  const altText = labelSchema.default as string;
  const imageDataURL =
    (dataSchema.default as string) || (externalIdSchema.default as string);
  const defaultWidth = Number(widthSchema.default as number);
  const defaultHeight = Number(heightSchema.default as number);
  const defaultAspectRatio = defaultWidth / defaultHeight;

  const controlWrapperRef = useRef<HTMLDivElement | null>(null);

  const [dimensions, setDimensions] = useState<Dimensions | null>(null);

  const { width } = useWindowSize();

  const backgroundImageUrl =
    imageDataURL && imageDataURL.startsWith('data:')
      ? imageDataURL
      : getAttachmentUrl(versionExternalId, imageDataURL);

  const adjustImageDimensions = () => {
    const controlWrapper = (
      controlWrapperRef?.current as HTMLDivElement
    ).closest('[data-part="ControlWrapper"]') as HTMLDivElement;

    const buildingToolsDiff = mode === WorkflowEngineMode.BUILD ? 100 : 0;
    const wrapperWidth = controlWrapper.offsetWidth - buildingToolsDiff;

    if (defaultWidth > wrapperWidth) {
      const width = Math.round(wrapperWidth);
      const height = Math.round(width / defaultAspectRatio);

      setDimensions({ width, height });
    }
  };

  useEffect(() => {
    adjustImageDimensions();
  }, [width]);

  useEffect(() => {
    if (controlWrapperRef?.current) {
      adjustImageDimensions();
    }
  }, []);

  return (
    <Stack ref={controlWrapperRef}>
      <div
        style={{
          backgroundImage: `url(${backgroundImageUrl})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          width: dimensions?.width || '100%',
          height: dimensions?.height || defaultHeight
        }}
        role="img"
        title={altText}
      ></div>
    </Stack>
  );
};
